import { render, staticRenderFns } from "./OdontogramaArcadaInferior.vue?vue&type=template&id=c9a676be&scoped=true"
import script from "./OdontogramaArcadaInferior.vue?vue&type=script&lang=js"
export * from "./OdontogramaArcadaInferior.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaArcadaInferior.vue?vue&type=style&index=0&id=c9a676be&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a676be",
  null
  
)

export default component.exports